import React, { Component } from "react";
import { Link } from "react-router-dom";
class CityXTourMuseums_SiteContent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div id="site-content" className="site-content clearfix">
        <div id="inner-content" className="inner-content-wrap">
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
          <div className="themesflat-row equalize sm-equalize-auto clearfix">
            <div className="span_1_of_6 bg-f7f">
              <div
                className="themesflat-spacer clearfix"
                data-desktop={60}
                data-mobile={60}
                data-smobile={60}
              />
              <div
                className="themesflat-content-box clearfix"
                data-margin="0 10px 0 43px"
                data-mobilemargin="0 15px 0 15px"
              >
                <div className="themesflat-headings style-2 clearfix">
                  <div className="sup-heading">MUZEJI I GALERIJE</div>
                  <h2 className="heading font-size-28 line-height-39">
                    CITY<b>X</b> TOUR &#38; PASS ATRAKCIJE
                  </h2>
                  <div className="sep has-width w80 accent-bg margin-top-20 clearfix" />
                  <p className="sub-heading margin-top-33 line-height-24">
                    Tražite način kako poboljšati prodaju ulaznica za vašu
                    atrakciju i pozicionirati se na listi najposjećenijih? CityX
                    Tour &#38; Pass besplatna je aplikacija namijenjena
                    turistima, što znači i vašim krajnjim korisnicima, koja
                    svojim inovativnim digitalnim rješenjima uspješno odgovara
                    na sve navedene izazove.
                  </p>
                </div>
              </div>
              <div
                className="themesflat-spacer clearfix"
                data-desktop={56}
                data-mobile={56}
                data-smobile={56}
              />
            </div>
            <div
              className="span_1_of_6 half-background "
              style={{
                backgroundImage:
                  "url(../assets/img/apps/cityx-tour-pass-museums.jpg",
                backgroundPosition: "left center",
              }}
            ></div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={39}
            data-mobile={39}
            data-smobile={39}
          />
          <div className="flat-content-wrap style-2 clearfix">
            <h5 className="title">
              KAKO UKLJUČITI ATRAKCIJU U CITYX TOUR &#38; PASS?
            </h5>
            <p>
              Proces je vrlo jednostavan, čak i ako nemate online prodaju! Nakon
              dogovora i potpisivanja ugovora- koji nije određen vremenskim
              trajanjem- dobivate svoj korisnički račun unutar naše business
              aplikacije sa detaljnim informacijama kako isti koristiti (pod
              time mislimo na prodaju ulaznica). Ne brinite, proces je vrlo
              jednostavan. Potom je, putem emaila (niže na stranici), potrebno
              dostaviti opis atrakcije na engleskom jeziku, kao i nekoliko
              fotografija. Slijedi uključenje muzeja ili galerije u CityX Tour
              &#38; Pass. Nakon aktivacije, koja traje maksimalno jedan dan,
              spremni ste za turiste!
            </p>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={37}
            data-mobile={35}
            data-smobile={35}
          />
          <div className="flat-content-wrap style-2 clearfix">
            <div className="item">
              <div className="inner">
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={10}
                  data-mobile={10}
                  data-smobile={10}
                />
                <h5 className="title">
                  KOJI SU PLUSEVI UKLJUČENJA ATRAKCIJE U CITYX TOUR &#38; PASS?
                </h5>
                <p>
                  Aplikacija u svim gradovima nudi dostupnost osnovnih modula,
                  koji se naravno, mogu proširiti u suradnju s gradskom upravom,
                  turističkom zajednicom, komunalnim poduzećem ili nekom drugom
                  gradskom službom. Osnovi moduli uključuju:
                </p>
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={8}
                  data-mobile={8}
                  data-smobile={8}
                />
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">
                        Veliki broj ciljanih gostiju - turista{" "}
                      </span>
                    </span>
                  </div>
                </div>
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">Ankete</span>
                    </span>
                  </div>
                </div>
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">
                        Novi kanal prodaje - online kupnja ulaznica
                      </span>
                    </span>
                  </div>
                </div>
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">
                        BESPLATAN sustav online naplate
                      </span>
                    </span>
                  </div>
                </div>
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">
                        BESPLATAN skener ulaznica koji je implementiran u
                        aplikaciju
                      </span>
                    </span>
                  </div>
                </div>
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">
                        Uvid u broj ulazaka u realnom vremenu
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <div
                className="themesflat-spacer clearfix"
                data-desktop={0}
                data-mobile={0}
                data-smobile={35}
              />
              <div
                className="themesflat-content-box clearfix"
                data-margin="0 0 0 11px"
                data-mobilemargin="0 0 0 0"
              >
                <div className="inner pd35 bg-ffc">
                  <h5 className="title text-white line-height-24 padding-left-7">
                    PREUZMITE PREZENTACIJSKE MATERIJALE ZA CITYX APP
                  </h5>
                  <br />
                  <div
                    className="themesflat-spacer clearfix"
                    data-desktop={16}
                    data-mobile={16}
                    data-smobile={16}
                  />
                  <div className="button-wrap has-icon icon-right size-14">
                    <a
                      href="CityX Pass HR.pdf"
                      className="themesflat-button bg-white color-333 w100 font-weight-400 no-letter-spacing pd26"
                      download
                    >
                      <span>
                        Turističke atrakcije .PDF{" "}
                        <span className="icon">
                          <i className="fa fa-file-pdf-o" />
                        </span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={37}
            data-mobile={35}
            data-smobile={35}
          />
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
          <div className="flat-content-wrap style-2 clearfix">
            <h5 className="title">
              KAKO PONUDITI PRODAJU ULAZNICA PREKO CITYX TOUR &#38; APLIKACIJE?
            </h5>
            <p>
              Javite nam se telefonski ili pošaljite zahtjev za kontaktom preko
              forme.
            </p>
            <div className="flat-content-wrap style-2 clearfix">
              <p style={{ padding: "0px" }}>
                <iframe
                  src="https://forms.monday.com/forms/embed/3699c1114b3775c5b4370be9337f7ad4?r=use1"
                  width={"100%"}
                  style={{
                    width: "200%",
                    height: "1000px",
                  }}
                ></iframe>
              </p>
            </div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
        </div>
      </div>
    );
  }
}

export default CityXTourMuseums_SiteContent;
